import { Component, Vue, Watch } from 'vue-property-decorator';

import { dateStrToFormat } from '@/filters/index';
import { OfflineResMgr } from '@/api/index';
import BaseInfo from '@/components/base-info.vue'; // 基本信息组件

@Component({
  components: {
    BaseInfo
  }
})
export default class OfflineResDetailMgr extends Vue {
  private currentResId: string = ''; // 当前资源Id
  private currentResource: any = {}; // 当前资源信息
  private dicts: any = {
    province: {},
    vCity: {},
    classify:　{},
    resource_status_offline: {},
    manufacturer: {}
  }; // 字典表
  private transferList: any = []; // 调拨列表
  private created() {
    this.currentResId = this.$route.params.id;
    this.getCurrentResData(); // 获取当前资源信息
    this.getDicts(); // 获取字典表
    this.getVprovinceDict(); // 获取省份字典表
    this.getVcityDict(); // 获取地市字典表
    this.getTransferList(); // 获取调拨列表
  }
  // 获取当前资源信息
  private getCurrentResData() {
    OfflineResMgr.getResourceById(this.currentResId).then(res => {
      this.currentResource = res.data;
    });
  }
  // 初始化设置数据
  get currentResData() {
    return {
      center: [
        { label: '设备型号', value: this.currentResource.deviceType },
        { label: '板卡型号', value: this.currentResource.pid },
        { label: '序列号', value: this.currentResource.serialNumber },
        { label: '来源设备名称', value: this.currentResource.deviceName },
        {
          label: '硬件归类',
          value: this.dicts.classify[this.currentResource.classify] || this.currentResource.classify
        },
        {
          label: '备件状态',
          value: this.dicts.resource_status_offline[this.currentResource.status] || this.currentResource.status
        },
        {
          label: '厂商',
          value: this.dicts.manufacturer[this.currentResource.manufacturer] || this.currentResource.manufacturer
        },
        { label: '硬件描述', value: this.currentResource.description },
        { label: '板卡软件版本', value: this.currentResource.vid },
        {
          label: '所属省份',
          value: this.dicts.province[this.currentResource.provinceId] || this.currentResource.provinceId
        },
        {
          label: '所属地市',
          value: this.dicts.vCity[this.currentResource.cityId] || this.currentResource.cityId
        },
        { label: '所属机房', value: this.currentResource.room },
        { label: '存放位置', value: this.currentResource.location },
        { label: '申请人', value: this.transferList.proposer },
        { label: '接收人员', value: this.transferList.receivePerson },
        { label: '接收人员联系方式', value: this.transferList.receivePersonTel },
        { label: '申请时间', value: dateStrToFormat(this.transferList.createTime) },
        { label: '工单编号', value: this.transferList.workorderNumber },
        { label: '工单标题', value: this.transferList.workorderName },
        { label: '故障设备名称', value: this.transferList.faultDeviceName },
        { label: '故障设备板卡序列号', value: this.transferList.faultDeviceSn },
        { label: '故障设备槽位', value: this.transferList.faultDeviceSlot },
        { label: '转出人', value: this.transferList.transferOutPerson },
        { label: '物流信息', value: this.transferList.logisticsNumber },
        { label: '备注', value: this.transferList.remark },
        { label: '调拨状态', value: this.transferList.status}
      ],
      right: [
        { label: '入库时间', value: dateStrToFormat(this.currentResource.offlineTime) },
        { label: '所属工程 ', value: this.currentResource.projectId },
        { label: '工程终验日期', value: dateStrToFormat(this.currentResource.projectCompleteTime) },
        { label: '工程合同名称', value: this.currentResource.projectContractName },
        { label: '投资类型', value: this.currentResource.investmentType},
        { label: '投资金额 ', value: this.currentResource.investmentMoney },
        { label: '转固资产序号 ', value: this.currentResource.propertyNumber },
        { label: '资产卡片号 ', value: this.currentResource.propertyCardNumber },
        { label: '实物编码 ', value: this.currentResource.entityNumber }
      ]
    };
  }
  // 获取字典表
  private getDicts() {
    const array = [ 'classify', 'resource_status_offline', 'manufacturer' ];
    for (const item of array) {
      OfflineResMgr.getDicts(item).then(dict => {
        for (const v of dict.data) {
          this.$set(this.dicts[item], v.value, v.displayName);
        }
      });
    }
  }
  // 获取省份
  private getVprovinceDict() {
    OfflineResMgr.getVprovinceList('', '').then(res => {
      for (const item of res.data) {
        this.$set(this.dicts.province, item.id, item.vProvinceName);
      }
    });
  }
  // 获取地市
  private getVcityDict() {
    OfflineResMgr.getVcityList('', '').then(res => {
      for (const item of res.data) {
        this.$set(this.dicts.vCity, item.id, item.vCityName);
      }
    });
  }
  // 获取调拨信息
  private getTransferList() {
    OfflineResMgr.getTransfeList(this.currentResId).then(res => {
      this.transferList = res.data;
    });
  }
}
